export default __webpack_public_path__ + "static/foyer-encastre-34902e99c9944bd0e809f3eee81aac09.jpg";